import React, { useState, useEffect } from 'react';
import { RiRefreshLine } from "react-icons/ri";
import { ClipLoader, PropagateLoader } from 'react-spinners';
import { FaSave, FaChevronLeft } from "react-icons/fa";
import Select from 'react-select';
import { toast } from 'react-toastify';
import LeaseApiService from '../../../services/apiService';
import { useSelector } from 'react-redux';
import { getCompany, getName } from '../../../../Redux/selecters';
import moment from 'moment/moment';
import { MdDelete } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import Modal from 'react-bootstrap/Modal';
import { useLocation, useNavigate } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import WindowedSelect from 'react-windowed-select';
import { addDays, parse, format } from 'date-fns';
import { useCurrency } from '../../../../INVENTORY/Layouts/currencyContext';
import { IoIosArrowForward } from "react-icons/io";

const RenueLeaseAgrement = () => {
    const userName = useSelector(getName);
    let navigate = useNavigate()
    const apiService = new LeaseApiService();
    const [FilterTab, setFilterTab] = useState(true);
    const { currencyPrecision } = useCurrency();
    const [AgentTab, setAgentTab] = useState(true);
    const [SecondaryTab, setSecondaryTab] = useState(true);
    const [barload, setBarLoad] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [cnt1, setcnt1] = useState();
    const [unitcharges, setunitcharge] = useState();
    const [unitFee, setunitFee] = useState();
    const [loading, setloader] = useState(false);
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const [entries, setEntries] = useState([]);
    const [remarksList, setRemarksList] = useState([]);
    const [editIndex, setEditIndex] = useState(null);
    const [unitRent, setUnitRent] = useState(true);
    const [datesEditable, setDatesEditable] = useState(false);
    const [datamsg, etdatamessage] = useState();
    const [msgModal, setmsgModal] = useState(false);
    const onOpenModal = () => setmsgModal(true);
    const onCloseModal = () => setmsgModal(false);
    const [leaseda, setLeaseDat] = useState();
    const location = useLocation();
    const leaseData = location.state;
    useEffect(() => {
        SetLeaseData()
    }, []);

    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    }
    const calculateDaysBetween = (from, to) => {
        const diff = new Date(to) - new Date(from);
        let leaseDate = Math.ceil(diff / (1000 * 60 * 60 * 24))
        return leaseDate + 1;
    }
    const getMonthDiff = (start, end) => {
        const startDate = new Date(start);
        const endDate = new Date(end);

        if (endDate < startDate) return 0;

        // Calculate month difference
        let months = (endDate.getFullYear() - startDate.getFullYear()) * 12;
        months += endDate.getMonth() - startDate.getMonth();

        // Include last month if end day >= start day
        if (endDate.getDate() >= startDate.getDate()) {
            months += 1;
        }

        return months;
    };
    const SetLeaseData = async () => {
        if (leaseData) {
            setBarLoad(true)
            // drpopDownApi list
            const dropparams = new URLSearchParams();
            dropparams.append('dropdownTypes', 'ReservationProductNames,ReservationTenantNames,ReservationPropertyNames,ReservationSalesPersons,ReservationAgents,ReservationLeaseRemarks,ReservationPropetyManagerNames,ReservationTypes');
            const customerRes = await apiService.getApiParamater('GET_MULTI_DROP_RESERV', `?${dropparams.toString()}`);
            setRemarksList(customerRes?.data?.dropdowns?.LeaseRemarks);

            const params = new URLSearchParams();
            params.append('Action', 'LeaseRenewCheckReceipt');
            params.append('GroupId', leaseData?.group_Id || leaseData?.groupId);
            const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
            setcnt1(res?.data?.result?.data)

            const UnitDetailsParams = new URLSearchParams();
            UnitDetailsParams.append('Action', 'LeaseRenewUnitDetails');
            UnitDetailsParams.append('GroupId', leaseData?.group_Id || leaseData?.groupId);
            const UnitDetailsres = await apiService.getApiParamater('GET_UNITNO_DATA', `?${UnitDetailsParams.toString()}`);

            const unitchargesParams = new URLSearchParams();
            unitchargesParams.append('Action', 'LeaseRenewUnitCharges');
            unitchargesParams.append('PropertyNo', leaseData?.property_Id);
            unitchargesParams.append('UnitNo', leaseData?.unit_No);
            const unitchargesres = await apiService.getApiParamater('GET_UNITNO_DATA', `?${unitchargesParams.toString()}`);
            setunitcharge(unitchargesres?.data?.result?.data)
            let Unitcharge = unitchargesres?.data?.result?.data
            const unitFeeParam = new URLSearchParams();
            unitFeeParam.append('Action', 'LeaseRenewUnitFeeAndCount');
            unitFeeParam.append('PropertyNo', leaseData?.property_Id);
            unitFeeParam.append('UnitNo', leaseData?.unit_No);
            unitFeeParam.append('PeriodFrom', leaseData?.lease_Date);
            unitFeeParam.append('PeriodTo', leaseData?.lease_Expiry);
            const unitFeeres = await apiService.getApiParamater('GET_UNITNO_DATA', `?${unitFeeParam.toString()}`);
            setunitFee(unitFeeres?.data?.result?.data)
            let leaserec = UnitDetailsres?.data?.result?.data
            let unitFee = unitFeeres?.data?.result?.data

            let agent = customerRes?.data?.dropdowns?.SalesPersons?.find((comp) => comp.text === leaserec?.SalesPerson)
            let broker = customerRes?.data?.dropdowns?.Agents?.find((comp) => comp.text === leaserec?.Agent)
            let selectedType = customerRes?.data?.dropdowns?.ReservationTypes?.find((comp) => comp.text === leaserec?.PortableWater)
            // Api Call for Customer1
            setLeaseDat(leaserec)
            const custparams = new URLSearchParams();
            custparams.append('Action', 'GetCustomerDetailsByTenantNo');
            custparams.append('TenantNo', leaserec?.Cust1_No);
            const custRes = await apiService.getApiParamater('GET_RESERV_COMMON', `?${custparams.toString()}`);
            let cust1data = custRes?.data?.result?.data
            // Api Call for customer 2
            const cust2params = new URLSearchParams();
            cust2params.append('Action', 'GetCustomerDetailsByTenantNo');
            cust2params.append('TenantNo', leaserec?.Cust2_No);
            const cust2Res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${cust2params.toString()}`);
            let cust2data = cust2Res?.data?.result?.data
            setTenantDetails({
                ...tenantDetails,
                agent: { label: agent?.text === "0" ? "" : agent?.text, value: agent?.value },
                broker: { label: broker?.text === "0" ? "" : broker?.text, value: broker?.value },
                type: { label: selectedType?.text === "0" ? "" : selectedType?.text, value: selectedType?.value },
                tanent1: { label: leaserec?.Cust1_Name === "0" ? "" : leaserec?.Cust1_Name, value: leaserec?.Cust1_No },
                tanent1Code: { label: leaserec?.Cust1_No === "0" ? "" : leaserec?.Cust1_No, value: cust1data },
                tanent2: { label: leaserec?.Cust2_Name === "0" ? "" : leaserec?.Cust2_Name, value: leaserec?.Cust2_No },
                tanent2Code: { label: leaserec?.Cust2_No === "0" ? "" : leaserec?.Cust2_No, value: cust2data },
            });

            if (leaserec) {
                const isLeapYear = (year) =>
                    (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;

                const isDateBetween = (date, start, end) =>
                    date >= start && date <= end;

                const today = new Date();

                // Convert Lease_Expiry ("08-Jul-2027") to a Date object
                const leaseExpiryDate = parse(leaserec.Lease_Expiry, 'dd-MMM-yyyy', new Date());
                // Period From is the day after Lease_Expiry
                const periodFrom = addDays(leaseExpiryDate, 1);

                // Base lease term
                let leaseTermDays = parseInt(leaserec.LeaseTerm, 10) || 365;

                // Tentative Period To
                let periodTo = addDays(periodFrom, leaseTermDays - 1);

                // 🔹 Check if Feb 28 of any leap year falls within the period
                for (let year = periodFrom.getFullYear(); year <= periodTo.getFullYear(); year++) {
                    if (isLeapYear(year)) {
                        const feb28 = new Date(year, 1, 28); // Month is 0-based (1 = Feb)

                        if (isDateBetween(feb28, periodFrom, periodTo)) {
                            leaseTermDays += 1;
                            break; // add only once
                        }
                    }
                }

                // 🔹 Final Period To after adjustment
                const finalperiodTo = addDays(periodFrom, leaseTermDays - 1);
                
                const leaseTermInMonths = getMonthDiff(periodFrom, finalperiodTo);
                const formattedEntry = {
                    Property: {
                        value: leaserec.Property_Id || "", // → property_Id
                        label: leaserec.Property_Name || "" // → propertyName
                    },
                    Unit: {
                        value: leaserec.Unit_No || "", // → unitNo
                        label: leaserec.Unit_No || ""
                    },
                    reservation: {
                        value: {
                            value: "Lease Agreement Remarks",
                            text: leaserec.RentPI_Remarks || "" // → rentPI_Remarks
                        },
                        label: "Lease Agreement Remarks"
                    },
                    remarks1: leaserec.LeaseTermInMonths?.toString() || "", // → remarks
                    remarks2: leaserec.RentPI_Remarks || "", // → rentPI_Remarks
                    All_In_Rent: Unitcharge?.All_In_Rent || 0,
                    Bedrooms: Unitcharge?.Bedrooms || "", // not available in API
                    Floor: Unitcharge?.Floor || "", // not available in API
                    Installments: leaseTermInMonths || 0, // → paymentTermNoOfChqs
                    LLEMailID: "", // not available in API
                    Landlord: Unitcharge?.Landlord || "", // → exp1
                    MuncAcNo: Unitcharge?.MuncAcNo || "0", // hardcoded
                    PEmail: "", // not in API
                    Parking: "0", // default
                    Parking_Price: 0, // → shopFit_Deposit
                    Ref_No: Unitcharge?.Ref_No || leaserec.Exp8 || "", // → exp8, unitRefNo
                    Rent_Per_Annum: parseFloat(Unitcharge?.Rent_Per_Annum) || 0, // → rentPerAnnum
                    Rent_Per_period: parseFloat(leaserec.TotalPrice) || 0, // → totalPrice
                    Rent_Per_Month: parseFloat(leaserec.Exp12)?.toFixed(currencyPrecision?.decimalNumbers) || 0, // → rentPI_Years
                    Rent_Per_Day: parseFloat(Unitcharge?.Rent_Per_Day) ? (parseFloat(Unitcharge?.Rent_Per_Day) / 30).toFixed(6) : "0",
                    Security_Deposit: 0, // → security_Deposit
                    Tenant_Commission: 0, // → leasing_Fee
                    Total_Area: parseFloat(Unitcharge?.Total_Area) || 0, // → totalArea
                    Unit_Class: Unitcharge?.Unit_Class || leaserec.Exp7 || "", // → unitClass
                    leaseFee: leaserec.Leasing_Fee?.toString() || "", // → leasing_Fee again
                    advanceRent: parseFloat(leaserec.Exp13) || 0, // → exp13
                    electricty: leaserec?.Exp11 || "", // → exp11
                    // electricty: leaserec.DEWA?.trim() || "", // → exp11
                    term: leaserec.Exp10 || "", // → exp10 (e.g., "Less Than Year")
                    month: parseInt(leaserec.Exp14) || 0, // → exp14
                    days: parseInt(leaserec.Exp20) || 0, // → exp14
                    filter: "",
                    serviceCharges: "0", // → service_Charge
                    rentFree: leaserec?.Advance, // manually set to advance if needed → advance
                    Rent_Month: parseFloat(leaserec.RentPI_Years) || 0, // → exp12
                    // leaseTerm: leaserec.LeaseTerm?.toString() || "", // → leaseTerm
                    // periodFrom: leaserec.Lease_Date || "", // → rentCommencementDate
                    // periodto: leaserec.Lease_Expiry || "", // → lease_Expiry
                    // transDate: leaserec.Exp4 || "",// → exp4, 
                    transDate: today,
                    periodFrom: periodFrom,
                    periodto: finalperiodTo,
                    leaseTerm: leaseTermDays.toString()

                };
                setEntries([formattedEntry]);
                setBarLoad(false)
            }
        }
    }
    // Tenant Details where tenant and agents, Broker details stored
    const [tenantDetails, setTenantDetails] = useState({
        tanent1: [],
        tanent1Code: [],
        tanent2: [],
        tanent2Code: [],
        agent: [],
        prpManager: [],
        broker: [],
        package: [],
        type: [],
    });
    // FormData  where Property and Unit  details stored
    const [formData, setFormData] = useState({
        Property: [],
        Unit: [],
        reservation: [],
        remarks1: '',
        remarks2: '',
        Unit: '',
        All_In_Rent: '',
        Bedrooms: '',
        Floor: '',
        Installments: '',
        LLEMailID: '',
        Landlord: '',
        MuncAcNo: '',
        PEmail: '',
        Parking: '',
        Parking_Price: '',
        Ref_No: '',
        Rent_Per_Annum: '',
        Rent_Per_period: '',
        Rent_Per_Month: '',
        Rent_Per_Day: '',
        Security_Deposit: '',
        Tenant_Commission: '',
        Total_Area: '',
        Unit_Class: '',
        leaseTerm: '1',
        transDate: '',
        periodto: '',
        periodFrom: '',
        leaseFee: '',
        advanceRent: 0,
        electricty: '',
        term: '',
        month: 2,
        days: '',
        rentFree: '',
        filter: '',
        serviceCharges: '',
    });
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    }
    // unit funtions
    // Handle change function where i store unit details that entered  in input fields of unit  
    const handleChange = async (e) => {
        const { name, value } = e.target;
        if (name === 'Rent_Per_Month') {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            const params = new URLSearchParams();
            params.append('Action', 'CalculateRentByMonth');
            params.append('PeriodFrom', moment(formData?.periodFrom).format("DD-MMM-YYYY"));
            params.append('PeriodTo', moment(formData?.periodto).format("DD-MMM-YYYY"));
            params.append('Commontext', value);
            const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
            let result = res?.data?.result?.data?.RentPerAnnum
            setFormData((prev) => ({
                ...prev,
                Rent_Per_period: result || 0,
            }));
            let rentPerMonth = value
            advanceRentCalculation({ rentPerMonth })
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value
            }));
        }
    }
    const dataset = () => {

        // Edit mode or add new
        if (editIndex !== null) {
            const updatedEntries = [...entries];
            updatedEntries[editIndex] = formData;
            setEntries(updatedEntries);
            setEditIndex(null);
        } else {
            setEntries((prev) => [...prev, formData]);
        }
        // Reset form
        const today = new Date();
        const formatted = formatDate(today);
        setDatesEditable(false);

        setFormData({
            Property: [{ label: '', value: '' }],
            Unit: [{ label: '', value: '' }],
            reservation: [],
            remarks1: '',
            remarks2: '',
            All_In_Rent: '',
            Bedrooms: '',
            Floor: '',
            Installments: '',
            LLEMailID: '',
            Landlord: '',
            MuncAcNo: '',
            PEmail: '',
            Parking: '',
            Parking_Price: '',
            Ref_No: '',
            Rent_Per_Annum: '',
            Rent_Per_period: '',
            Rent_Per_Month: '',
            Rent_Per_Day: '',
            Security_Deposit: '',
            Tenant_Commission: '',
            Total_Area: '',
            Unit_Class: '',
            leaseFee: '',
            advanceRent: 0,
            electricty: '',
            term: '',
            month: 2,
            days: '',
            rentFree: '',
            filter: '',
            serviceCharges: '',
            transDate: formatted,
            periodFrom: formatted,
            periodto: formatted,
            leaseTerm: '1',
        });
        onCloseModal()
    }
    const handleUpdate = () => {

        // for (const item of formData) {

        if (!formData.Property?.label) {
            toast.warning(`Please Select Property`);
            return;
        } else if (!formData.Unit?.label) {
            toast.warning(`Please Select Unit No`);
            return;
        } else if (!formData?.term) {
            toast.warning(`Please select any Lease Term`);
            return;
        } else if (!formData?.periodFrom) {
            toast.warning(`Please select Period From`);
            return;
        } else if (!formData?.periodto) {
            toast.warning(`Please select Period to`);
            return;
        } else if (!formData?.Rent_Per_period) {
            toast.warning(`Please Enter Ren Per Period amount`);
            return;
        } else if (!formData?.Rent_Per_Annum) {
            toast.warning(`Please Enter Ren Per Annum amount`);
            return;
        } else if (!formData?.Unit_Class) {
            toast.warning(`Unit class is unavailable please select another Unit`);
            return;
        }
        // }
        if (editIndex !== null) {
            const updatedEntries = [...entries];
            updatedEntries[editIndex] = formData;
            setEntries(updatedEntries);
            setEditIndex(null);
        } else {
            setEntries((prev) => [...prev, formData]);
        }

        // Clear form
        setFormData({
            Property: [],
            Unit: [],
            reservation: [],
            remarks1: '',
            remarks2: '',
            Unit: '',
            All_In_Rent: '',
            Bedrooms: '',
            Floor: '',
            Installments: '',
            LLEMailID: '',
            Landlord: '',
            MuncAcNo: '',
            PEmail: '',
            Parking: '',
            Parking_Price: '',
            Ref_No: '',
            Rent_Per_Annum: '',
            Rent_Per_period: '',
            Rent_Per_Month: '',
            Rent_Per_Day: '',
            Security_Deposit: '',
            Tenant_Commission: '',
            Total_Area: '',
            Unit_Class: '',
            leaseTerm: '1',
            transDate: '',
            periodto: '',
            periodFrom: '',
            leaseFee: '',
            advanceRent: 0,
            electricty: '',
            term: '',
            month: 2,
            days: '',
            rentFree: '',
            filter: '',
            serviceCharges: '',
        });
    }
    const handleEdit = (index) => {
        setFormData(entries[index]);
        setEditIndex(index);
    }
    const handleRemarksChange = (selectedOption) => {
        setFormData({
            ...formData,
            reservation: selectedOption,
            remarks2: selectedOption?.value?.text
        });
    }
    const handleTermChange = async (e) => {
        const term = e.target.value;
        const today = new Date();
        let periodFrom = today;
        let periodTo = new Date(today);

        if (term === "Short Term") {
            periodTo.setMonth(periodTo.getMonth() + 3);
            periodTo.setDate(periodTo.getDate() - 1);
        } else if (term === "Long Term" || term === "Less than one Year") {
            periodTo.setFullYear(periodTo.getFullYear() + 1);
            periodTo.setDate(periodTo.getDate() - 1); // Subtract 1 day to make it inclusive
        }
        const formattedFrom = formatDate(periodFrom);
        const formattedTo = formatDate(periodTo);
        const leaseTerm = calculateDaysBetween(formattedFrom, formattedTo);
        const params = new URLSearchParams();
        params.append('Action', 'CalculateRentByMonth');
        params.append('PeriodFrom', moment(formattedFrom).format("DD-MMM-YYYY"));
        params.append('PeriodTo', moment(formattedTo).format("DD-MMM-YYYY"));
        params.append('Commontext', formData?.Rent_Per_Month);
        const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
        let result = res?.data?.result?.data?.RentPerAnnum
        const leaseTermInMonths = getMonthDiff(formattedFrom, formattedTo);
        setFormData((prev) => ({
            ...prev,
            term,
            periodFrom: formattedFrom,
            periodto: formattedTo,
            Rent_Per_period: result,
            Installments: leaseTermInMonths,
            // Rent_Per_Annum: result,
            leaseTerm: leaseTerm.toString(),
        }));
        advanceRentCalculation({ leaseTerm }, result)
        setDatesEditable(true);
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value); // Ensure "DD-MMM-YYYY"
        let updatedDates = { ...formData, [name]: updatedValue };

        // Only auto-set periodto when periodFrom is selected and term is specific
        if ((formData.term === "Long Term" || formData.term === "Less than one Year") && name === 'periodFrom') {
            const fromDate = moment(updatedValue, "DD-MMM-YYYY");
            const toDate = fromDate.clone().add(1, 'year').subtract(1, 'day');
            updatedDates.periodto = toDate.format("DD-MMM-YYYY");
        }

        // Grab up-to-date periodFrom and periodto
        const from = name === 'periodFrom' ? updatedValue : formData.periodFrom;
        const to = name === 'periodto' ? updatedValue : updatedDates.periodto || formData.periodto;

        // If both dates exist, validate and calculate rent
        if (from && to) {
            const fromDate = moment(from, "DD-MMM-YYYY");
            const toDate = moment(to, "DD-MMM-YYYY");

            if (fromDate.isAfter(toDate)) {
                toast?.warning('Period From date must be less than Period To date.');
                return;
            }

            const params = new URLSearchParams();
            params.append('Action', 'CalculateRentByMonth');
            params.append('PeriodFrom', fromDate.format("DD-MMM-YYYY"));
            params.append('PeriodTo', toDate.format("DD-MMM-YYYY"));
            params.append('Commontext', formData?.Rent_Per_Month);
            const leaseTermInMonths = getMonthDiff(fromDate, toDate);

            try {
                const res = await apiService.getApiParamater('GET_RESERV_COMMON', `?${params.toString()}`);
                const result = res?.data?.result?.data?.RentPerAnnum;
                const leaseTerm = calculateDaysBetween(from, to);
                updatedDates.leaseTerm = leaseTerm.toString();
                updatedDates.Rent_Per_period = result;
                updatedDates.Installments = leaseTermInMonths;
                advanceRentCalculation({ result });
            } catch (error) {
                console.error("API call failed", error);
            }
        }

        setFormData(updatedDates);
    }
    const advanceRentCalculation = (rentPerMonths, result) => {
        setFormData((prev) => ({
            ...prev,
            advanceRent: 0,
        }));
        let rentPerMonth = rentPerMonths?.rentPerMonth ? rentPerMonths?.rentPerMonth : formData?.Rent_Per_Month || formData?.Rent_Per_Month || 0
        let leaseTerm = rentPerMonths?.leaseTerm || formData?.leaseTerm || 0
        let rentPerPeriod = result || formData?.Rent_Per_period || 0
        const rentPerDay = parseFloat(rentPerPeriod / leaseTerm)
        let monthValue = rentPerMonths?.value === '' ? 0 : rentPerMonths?.value || formData?.month || 0
        let dayValue = rentPerMonths?.dayvalue === '' ? 0 : rentPerMonths?.dayvalue || formData?.days || 0
        let advanceAmount = (rentPerMonth * monthValue) + (dayValue * rentPerDay)
        setFormData((prev) => ({
            ...prev,
            advanceRent: advanceAmount,
        }));
    }
    const handleadvanceChange = (e) => {
        const { name, value } = e.target;
        if (name === 'month') {
            setFormData((prev) => ({
                ...prev,
                month: value,
            }));

            advanceRentCalculation({ value })
        } else if (name === 'days') {
            let dayvalue = value
            setFormData((prev) => ({
                ...prev,
                days: value,
            }));
            advanceRentCalculation({ dayvalue })
        }
    }
    const handleSave = async () => {
        try {
            setloader(true);
            const currentDatetimeUTC = new Date().toISOString();
            const valid1params = new URLSearchParams();
            valid1params.append('Action', 'CheckRenwAgreementValidPeriod');
            valid1params.append('PeriodFrom', moment(entries[0]?.periodFrom).format("DD-MMM-YYYY"));
            valid1params.append('PeriodTo', moment(entries[0]?.periodto).format("DD-MMM-YYYY"));
            valid1params.append('PropertyNo', entries[0]?.Property?.value);
            valid1params.append('UnitNo', entries[0]?.Unit?.label);
            valid1params.append('UnitRefNo', entries[0]?.Ref_No);
            const Vaid1Res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${valid1params.toString()}`);

            if (Vaid1Res?.data?.result?.data?.Count > 0 || Vaid1Res?.data?.result?.data?.Count === 1) {
                toast.warning("Please Select Correct Lease Period")
                setloader(false)
                return;
            } else {
                const params = new URLSearchParams();
                params.append('Action', 'LeaseRenewCheckFromDate');
                params.append('PeriodFrom', moment(entries[0]?.periodFrom).format("DD-MMM-YYYY"));
                const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);

                let msgdat = res?.data?.result?.data
                if (msgdat?.IsActive != true) {
                    toast.warning("Please Select Correct Lease Period")
                    setloader(false)
                    return;
                }
                else if (msgdat?.IsActive === true) {

                    // Build lease reservation list
                    const leaseReservationMasterlst = entries.map((item, index) => {
                        const leaseTermInMonths = getMonthDiff(item?.periodFrom, item?.periodto);
                        
                        return {
                            leaseNo: "0",
                            group_Id: "0",
                            recordId: "0",
                            cust1_No: tenantDetails?.tanent1?.value || "0",
                            cust1_Name: tenantDetails?.tanent1?.label || "0",
                            cust2_No: tenantDetails?.tanent2?.value || "0",
                            cust2_Name: tenantDetails?.tanent2?.label || "0",
                            custPri_ContactNo: tenantDetails?.tanent1Code?.value?.MainContactno || "0",
                            custPri_Email: tenantDetails?.tanent1Code?.value?.Email_id || "0",
                            custPri_PassportID: "0",
                            custPri_Nationality: tenantDetails?.tanent1Code?.value?.Nationality || "0",
                            custPri_VatRegNo: "0",
                            custJoint_CustNo: tenantDetails?.tanent2Code?.value?.Customer_no || "0",
                            custJoint_CustName: tenantDetails?.tanent2Code?.value?.Customer_Name || "0",
                            custJoint_ContactNo: tenantDetails?.tanent2Code?.value?.MainContactno || "0",
                            custJoint_Email: tenantDetails?.tanent2Code?.value?.Email_id || "0",
                            custJoint_PassportID: "0",
                            custJoint_Nationality: tenantDetails?.tanent2Code?.value?.Nationality || "0",
                            custJoint_VatRegNo: "0",
                            // Agent Passes in Sale Person
                            salesPerson: tenantDetails?.agent?.label || "0",
                            // Broker Passes in Agent
                            agent: tenantDetails?.broker?.label || "0",
                            tenantMoveType: tenantDetails?.type?.label || "0",
                            propManager: tenantDetails?.prpManager?.label || "0",
                            package: tenantDetails?.package?.label || "0",
                            rentPerAnnum: item?.Rent_Per_Annum.toString(),
                            leasing_Fee: item?.Tenant_Commission.toString(),
                            service_Charge: item?.serviceCharges.toString(),
                            // Rent free amount in advance
                            advance: item?.rentFree.toString(),
                            security_Deposit: item?.Security_Deposit.toString(),
                            misc_Charges: "0",
                            dewa: "0",
                            shopFit_Deposit: item?.Parking_Price.toString(),
                            leaseTerm: item?.leaseTerm === '366' ? '365' : item?.leaseTerm,
                            leaseTermInMonths: leaseTermInMonths?.toString(),
                            rentPaymentTerm: "0",
                            paymentTermNoOfChqs: leaseTermInMonths,
                            // date
                            rentCommencementDate: moment(item?.periodFrom).format("DD-MMM-YYYY"),
                            shopFitPeriod: "0",
                            anticipatedPremisesHandoverDate: "0",
                            anticipatedOpeningDate: "0",
                            status: "Active",
                            pay_Option: "Group",
                            serviceChargeIncrease_Remarks: "0",
                            remarks: item?.remarks1,
                            advHandoverNotice: "0",
                            handoverNotice: "0",
                            premisesHandoverDate: "0",
                            advNoticeOpening: "0",
                            mallOpeningDate: "0",
                            longStopDate: "0",
                            insurancePolicy: "0",
                            insuredAmount: "0",
                            addendum: "0",
                            rentPI: item?.Rent_Per_Annum.toString(),
                            rentPI_Years: item?.Rent_Month.toString(),
                            rentPI_Remarks: item?.remarks2.toString(),
                            tenantManual: "0",
                            tenantManualDate: "01-Jan-1900",
                            franchiseAgreement: "0",
                            franchiseExpDate: "01-Jan-1900",
                            franchiseRemarks: "0",
                            districtCooling: "0",
                            portableWater: tenantDetails?.type?.label,
                            totalArea: item?.Total_Area.toString(),
                            totalPrice: item?.Rent_Per_period.toString(),
                            totalPriceByUser: item?.Rent_Per_period.toString(),
                            exp1: item?.Landlord,
                            exp2: "0",
                            exp3: "0",
                            exp4: moment(item?.transDate).format("DD-MMM-YYYY"),
                            exp5: "0",
                            exp6: "0",
                            exp7: item?.Unit_Class || "0",
                            exp8: item?.Ref_No || "0",
                            exp9: item?.Rent_Per_Annum.toString(),
                            exp10: item?.term || "0",
                            exp11: item?.electricty || "0",
                            // Rent per month taxtbox value
                            exp12: item?.Rent_Per_Month.toString(),
                            exp13: item?.advanceRent.toString(),
                            exp14: item?.month?.toString(),
                            // Variable Charges
                            exp15: "0",
                            exp16: tenantDetails?.prpManager?.label || "0",
                            exp17: tenantDetails?.package?.label || "0",
                            exp18: "0",
                            exp19: "0",
                            // Days Dropdown 
                            //exp20: item?.days?.toString(),
                            exp20: "Renew",
                            modified_By: userName,
                            modified_On: currentDatetimeUTC,
                            seriesNo: "0",
                            discountPercent: "0",
                            discount: "0",
                            taxCode: "0",
                            taxInclusive: "0",
                            vatPercent: "0",
                            stPercent: "0",
                            st: "0",
                            vat: "0",
                            rent: item?.Rent_Per_period?.toString(),
                            total: item?.Rent_Per_period?.toString(),
                            propertyNo: item?.Property?.value || "0",
                            propertyName: item?.Property?.label || "0",
                            unitNo: item?.Unit?.label || "0",
                            unitRefNo: item?.Ref_No || "0",
                            unitClass: item?.Unit_Class || "0",
                            taxPercent: "0",
                            landlord: item?.Landlord || "0",
                            municipalityNo: item?.MuncAcNo || "0",
                            lease_Date: moment(item?.periodFrom).format("DD-MMM-YYYY"),
                            lease_Expiry: moment(item?.periodto).format("DD-MMM-YYYY"),
                            category_Mix: "0",
                            property_Id: item?.Property?.value || "0",
                            financialPosting: false,
                            groupPayment: true,
                            groupLeaseNo: true,
                            psOtherPayment: true,
                            installmentInvoice: false,
                            otherPaymentInvoice: true
                        };
                    });

                    const body = {
                        leaseReservationMain: {
                            leaseReservationMasterlst,
                            validateMeassage: datamsg || "0"
                        }
                    };

                    const postRes = await apiService.post('POST_RENEW_DATA', body);

                    if (postRes?.data?.statusCode === 201) {
                        if (postRes?.data?.result?.leaseNo && postRes?.data?.result?.groupId) {
                            toast.success(`${postRes?.data?.result?.leaseNo} Created successfully`);
                            setloader(false);
                            navigate('/Lease/Management/Lease/Renewal/Listing')
                        } else {
                            toast.warning(postRes?.data?.message)
                            setloader(false);
                        }
                    } else {
                        toast.warning(`${postRes?.data?.message}`);
                        setloader(false);
                    }
                }
            }
        } catch (error) {
            console.error('Error Save Data', error);
            setloader(false);
        } finally {
            setloader(false);
        }
    }
    const handleBackClick = () => {
        window.history.back();
    };
    return (
        <div className="p-3">
            <div className='mb-3'><h6>Lease Renew</h6></div>
            <div className='d-flex justify-content-between border-box2 p-3' style={{ borderRadius: "8px" }}>
                <div className='nav nav-pills start overslid d-flex gap-4'>
                    <div
                        className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(0)}
                    >
                        Tenant Details
                    </div>
                    <div
                        className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(1)}
                    >
                        Unit Details
                    </div>
                </div>
                <div className='col-lg-4 d-flex gap-1'>
                    {loading === true ?
                        <div className='mainbtn flex-end gap-2 w-50'>
                            <ClipLoader color="#ffffff" className='mt-1' size={25} />
                        </div>
                        :
                        <div className='mainbtn flex-end gap-2 w-50' onClick={handleSave}>
                            <FaSave color='#fff' className='center mt-2 mx-2' />
                            <div className='center'>Save</div>
                        </div>
                    }
                    <div className='mainbtnRed flex-end gap-2 w-50'>
                        <RiRefreshLine color='#fff' className='center mt-2 mx-2' />
                        <div className='center'>Reset</div>
                    </div>
                    <div className='mainbtnSecondary flex-end gap-2 w-50' onClick={handleBackClick}>
                        <FaChevronLeft color='#fff' className='center mt-2 mx-2' />
                        <div className='center'>Back</div>
                    </div>
                </div>
            </div>
            {gridVisibility[0] && (
                <div className=''>
                    <div className="cost-center-section mt-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setFilterTab(!FilterTab)}>
                            <div className='param-label pt-1 col-2'>Tenant Primary Details</div>
                            <IoIosArrowForward
                                size={30}
                                className={`arrow fade-rotate ${FilterTab ? "open" : ""}`}
                            />
                        </div>
                        <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                                {barload === true ?
                                    <div className='center p-5'>
                                        <PropagateLoader color="#6E5199" />
                                    </div> :
                                    <div className="form-group grid-contain ">
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant Name</label>
                                            <WindowedSelect
                                                className="w-75 p-0"
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}

                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                                menuShouldScrollIntoView={false}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                                        color: '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000',
                                                        },
                                                    }),
                                                }}
                                                value={tenantDetails.tanent1}
                                                isDisabled
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant No</label>
                                            <WindowedSelect
                                                className="w-75 p-0"
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}

                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                                menuShouldScrollIntoView={false}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                                        color: '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000',
                                                        },
                                                    }),
                                                }}
                                                value={tenantDetails.tanent1Code}
                                                isDisabled
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No.</label>
                                            <input type="text" className="p-2 form-control w-75" name="periodto" value={tenantDetails?.tanent1Code?.value?.MainContactno} disabled />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Email</label>
                                            <input type="email" className="p-2 form-control w-75" value={tenantDetails?.tanent1Code?.value?.Email_id} disabled />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Trade Lic</label>
                                            <input type="text" className="p-2 form-control w-75" name="installments" value={tenantDetails?.tanent1Code?.value?.TradeLicNo} disabled />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Nationality</label>
                                            <input type="text" className="p-2 form-control w-75" name="remarks" value={tenantDetails?.tanent1Code?.value?.Nationality} disabled />

                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="cost-center-section mt-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setAgentTab(!AgentTab)}>
                            <div className='param-label pt-1 col-2'>Tenant Secondary Details</div>
                            <IoIosArrowForward
                                size={30}
                                className={`arrow fade-rotate ${AgentTab ? "open" : ""}`}
                            />
                        </div>
                        <div className={`slide-content ${AgentTab ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${AgentTab ? 'slide-in' : 'slide-out'}`}>
                                {barload === true ?
                                    <div className='center p-5'>
                                        <PropagateLoader color="#6E5199" />
                                    </div> :
                                    <div className="form-group grid-contain ">
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant Name</label>
                                            <WindowedSelect
                                                className="w-75 p-0"
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}

                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                                menuShouldScrollIntoView={false}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                                        color: '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000',
                                                        },
                                                    }),
                                                }}
                                                value={tenantDetails.tanent2}
                                                isDisabled
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant No</label>
                                            <WindowedSelect
                                                className="w-75 p-0"
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}

                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                                menuShouldScrollIntoView={false}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                                        color: '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000',
                                                        },
                                                    }),
                                                }}
                                                value={tenantDetails.tanent2Code}
                                                isDisabled
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No.</label>
                                            <input type="text" className="p-2 form-control w-75" name="periodto" value={tenantDetails?.tanent2Code?.value?.MainContactno} disabled />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Email</label>
                                            <input type="email" className="p-2 form-control w-75" value={tenantDetails?.tanent2Code?.value?.Email_id} disabled />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Trade Lic</label>
                                            <input type="text" className="p-2 form-control w-75" name="installments" value={tenantDetails?.tanent2Code?.value?.TradeLicNo} disabled />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Nationality</label>
                                            <input type="text" className="p-2 form-control w-75" name="remarks" value={tenantDetails?.tanent2Code?.value?.Nationality} disabled />

                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="cost-center-section mt-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setSecondaryTab(!SecondaryTab)}>
                            <div className='param-label pt-1 col-2'>Agent Details</div>
                            <IoIosArrowForward
                                size={30}
                                className={`arrow fade-rotate ${SecondaryTab ? "open" : ""}`}
                            />
                        </div>
                        <div className={`slide-content ${SecondaryTab ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${SecondaryTab ? 'slide-in' : 'slide-out'}`}>
                                {barload === true ?
                                    <div className='center p-5'>
                                        <PropagateLoader color="#6E5199" />
                                    </div> :
                                    <div className="form-group grid-contain ">
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Leaseing Agent</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}

                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                                menuShouldScrollIntoView={false}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={tenantDetails?.agent}
                                                isDisabled
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Broker</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}

                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                                menuShouldScrollIntoView={false}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={tenantDetails?.broker}
                                                isDisabled
                                            />
                                        </div>
                                        <div className="d-flex">
                                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Type</label>
                                            <Select
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 5,
                                                    padding: 9
                                                })}

                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                                menuShouldScrollIntoView={false}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                        color: state.isFocused ? '#000 ' : '#000',
                                                        ':hover': {
                                                            backgroundColor: '#F5F5F5',
                                                            color: '#000 ',
                                                        },
                                                    }),
                                                }}
                                                className="w-75 p-0"
                                                value={tenantDetails?.type}
                                                isDisabled
                                            />
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {gridVisibility[1] && (
                <div className="cost-center-section my-3">
                    <div className="d-flex cursor-pointer slide-header"
                        onClick={() => setUnitRent(!unitRent)}>
                        <div className='param-label pt-1'>Unit Rent Details</div>
                        <IoIosArrowForward
                            size={30}
                            className={`arrow fade-rotate ${unitRent ? "open" : ""}`}
                        />
                    </div>
                    <div className={`slide-content ${unitRent ? 'open' : 'closed'}`}>
                        <div className={`border-box2 p-3 ${unitRent ? 'slide-in' : 'slide-out'}`}>
                            <div className="form-group grid-contain ">
                                {/* PropertNo */}
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Property</label>
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}

                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        className="w-75 p-0"
                                        value={formData.Property}
                                        isDisabled
                                    />
                                </div>
                                <div className="d-flex gap-3">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Unit Ref No</label>
                                    <input type="text" className="p-2 form-control w-75" name="bedRooms"
                                        value={formData.Ref_No} disabled />
                                    <div className='text-bold center text-warning'>{formData?.Unit_Class}</div>
                                </div>
                                <div className="d-flex gap-3">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Electrical Consumption</label>
                                    <input type="number" className="p-2 form-control w-75" name="electricty"
                                        value={formData.electricty} onChange={handleChange} />
                                    <div className='center text-bold text-primary'>{(formData?.Rent_Per_Annum || 0)?.toFixed(currencyPrecision?.decimalNumbers)}</div>
                                </div>
                                {/* UnitNo */}
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Unit No *</label>
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}

                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        className="w-75 p-0"
                                        value={formData.Unit}
                                        isDisabled
                                    />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Rent for Period</label>
                                    <input type="number" className="p-2 form-control w-75" name="Rent_Per_period" disabled
                                        value={Number(formData.Rent_Per_period)?.toFixed(currencyPrecision?.decimalNumbers)} onChange={handleChange} />
                                </div>
                                <div className="d-flex gap-3">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Rent/Month</label>
                                    <input type="number" className="p-2 form-control w-75" name="Rent_Per_Month"
                                        value={formData.Rent_Per_Month} onChange={handleChange} />
                                    <div className='center text-primary'>{(formData?.Rent_Month || 0)?.toFixed(currencyPrecision?.decimalNumbers)}</div>
                                </div>
                                {/* Total Area */}
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Total Area</label>
                                    <input type="text" className="p-2 form-control w-75" name="noCommunity" disabled
                                        value={formData.Total_Area} />
                                </div>
                                {/* terms */}
                                <div className="d-flex gap-3 mb-3">
                                    {["Short Term", "Long Term", "Less than one Year"].map((label) => (
                                        <div className="form-check" key={label}>
                                            <input
                                                type="radio"
                                                className="form-check-input" disabled
                                                name="term"
                                                value={label}
                                                checked={formData.term === label}
                                                onChange={handleTermChange}
                                            />
                                            <label className="form-check-label">{label}</label>
                                        </div>
                                    ))}
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Security Deposit</label>
                                    <input type="number" className="p-2 form-control w-75" name="Security_Deposit" disabled
                                        value={Number(formData.Security_Deposit)?.toFixed(currencyPrecision?.decimalNumbers)} onChange={handleChange} />
                                </div>
                                {/* advance rend */}
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Bedroom(s)</label>
                                    <input type="email" className="p-2 form-control w-75" name="Bedrooms"
                                        value={formData.Bedrooms} disabled />
                                </div>
                                {/* transdate */}
                                <div className="d-flex">
                                    <label className="form-label pt-1 text-danger">TransDate</label>
                                    <DatePicker
                                        todayButton="Today" isDisabled disabled
                                        selected={formData?.transDate}
                                        onChange={(date) => handleDateChange({ name: 'transDate', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100 datepicker-icon"
                                    />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Service Charges</label>
                                    <input type="number" className="p-2 form-control w-100" name="serviceCharges" disabled
                                        value={Number(formData.serviceCharges)?.toFixed(currencyPrecision?.decimalNumbers)} onChange={handleChange} />
                                </div>
                                {/*  */}
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Parking</label>
                                    <input type="text" className="p-2 form-control w-75" name="Parking"
                                        value={Number(formData.Parking)?.toFixed(currencyPrecision?.decimalNumbers)} disabled />
                                </div>
                                {/* period from */}
                                <div className="d-flex mb-2">
                                    <label className="form-label pt-1 start">Period From</label>
                                    <DatePicker
                                        todayButton="Today"
                                        selected={formData.periodFrom ? new Date(formData.periodFrom) : null}
                                        onChange={(date) => handleDateChange({ name: 'periodFrom', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100 datepicker-icon"
                                    />
                                </div>

                                <div className="d-flex gap-2">
                                    <label className="form-label pt-1">Advance Rent</label>
                                    <input
                                        type="number"
                                        className="p-2 form-control w-25"
                                        name="advanceRent"
                                        value={Number(formData.advanceRent)?.toFixed(currencyPrecision?.decimalNumbers)}
                                        disabled
                                    />
                                    <select
                                        className="p-2 form-control w-25"
                                        value={formData.month} disabled
                                        name='month'
                                        onChange={handleadvanceChange}
                                    >
                                        <option value="">Select Month</option>
                                        {[...Array(12)].map((_, i) => (
                                            <option key={i + 1} value={i + 1}>
                                                {i + 1}
                                            </option>
                                        ))}
                                    </select>
                                    <select
                                        className="p-2 form-control w-25"
                                        value={formData.days}
                                        name='days' disabled
                                        onChange={handleadvanceChange}
                                    >
                                        <option value="">Select Days</option>
                                        {[...Array(31)].map((_, i) => (
                                            <option key={i + 1} value={i + 1}>
                                                {i + 1}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">LandLoard</label>
                                    <input type="text" className="p-2 form-control w-75" name="Landlord" disabled
                                        value={formData.Landlord} onChange={handleChange} />
                                </div>
                                {/* period to */}
                                <div className="d-flex mb-2">
                                    <label className="form-label pt-1 start">Period To</label>
                                    <DatePicker
                                        todayButton="Today"
                                        selected={formData.periodto ? new Date(formData.periodto) : null}
                                        onChange={(date) => handleDateChange({ name: 'periodto', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100 datepicker-icon"
                                    />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Parking Charges</label>
                                    <input type="number" className="p-2 form-control w-75" name="Parking_Price" disabled
                                        value={Number(formData.Parking_Price)?.toFixed(currencyPrecision?.decimalNumbers)} onChange={handleChange} />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Munc A/C No</label>
                                    <input type="text" className="p-2 form-control w-75" name="MuncAcNo" disabled
                                        value={formData.MuncAcNo} onChange={handleChange} />
                                </div>
                                {/* lease term */}
                                <div className="d-flex mb-2">
                                    <label className="form-label pt-1 start">Lease Term</label>
                                    <input
                                        type="text"
                                        className="p-2 form-control w-75"
                                        name="leaseTerm"
                                        value={formData.leaseTerm}
                                        disabled
                                    />
                                </div>

                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Leaseing Commission</label>
                                    <input type="number" className="p-2 form-control w-75" name="Tenant_Commission" disabled
                                        value={Number(formData.Tenant_Commission)?.toFixed(currencyPrecision?.decimalNumbers)} onChange={handleChange} />
                                </div>
                                {/* rent free */}
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Rent Free Amount</label>
                                    <input type="text" className="p-2 form-control w-75" name="rentFree" disabled
                                        value={Number(formData.rentFree)?.toFixed(currencyPrecision?.decimalNumbers)} onChange={handleChange} />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Remarks / Comments</label>
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}

                                        menuPortalTarget={document.body}
                                        menuPlacement="auto"
                                        menuShouldScrollIntoView={false}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        className="w-75 p-0"
                                        value={formData.reservation}
                                        options={remarksList?.map((cost) => ({ value: cost, label: cost?.value }))}
                                        onChange={(selectedOption) => handleRemarksChange(selectedOption)}
                                    />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Admin/Leasing Fee</label>
                                    <input type="number" className="p-2 form-control w-75" name="leaseFee" disabled
                                        value={Number(formData.leaseFee)?.toFixed(currencyPrecision?.decimalNumbers)} onChange={handleChange} />
                                </div>
                                <div className="d-flex">
                                    {editIndex !== null ?
                                        <button className="btn btn-primary my-3" onClick={handleUpdate}>
                                            {'Update'}
                                        </button> : ""
                                    }
                                </div>
                                <div className="d-flex">
                                    <textarea type="number" className="form-control" name="remarks2"
                                        value={formData.remarks2} onChange={handleChange} />
                                </div>
                                <div className="d-flex">
                                    <textarea type="number" className="form-control" name="remarks1"
                                        value={formData.remarks1} onChange={handleChange} />
                                </div>
                            </div>
                        </div>
                        <div className=" table-container  mt-4" style={{ overflowX: 'auto', height: "400px" }}>
                            <table>
                                <thead className='dynoTable p-0 m-0' >
                                    <tr>
                                        <th>Actions</th>
                                        <th>Property</th>
                                        <th>Unit</th>
                                        <th>Total Area</th>
                                        <th>Trans Date</th>
                                        <th>Period From</th>
                                        <th>Period To</th>
                                        <th>Rent for Period</th>
                                        <th>Security Deposit</th>
                                        <th>Ejari Charges</th>
                                        <th>Service Charges</th>
                                        <th>Parking Price</th>
                                        <th>Admin Fee</th>
                                        <th>Rent Free Amount</th>
                                        <th>No of Installments</th>
                                        <th>Lease Term</th>
                                        <th>Reservation/ Agreement</th>
                                        <th>Remarks</th>
                                    </tr>
                                </thead>
                                <tbody className='p-0 m-0'>
                                    {entries?.map((entry, index) => (
                                        <tr key={index} className='p-0 m-0'>
                                            <td className='gap-3 d-flex'>
                                                <div className='' onClick={() => handleEdit(index)}>
                                                    <FiEdit size={25} />
                                                </div>
                                            </td>
                                            <td className='m-0 p-0'><input className="p-1" value={entry.Property?.label} disabled style={{ width: "150px" }} /></td>
                                            <td><input className="p-1" value={entry.Unit?.label} disabled style={{ width: "100px" }} /></td>
                                            <td><input className="p-1" value={entry.Total_Area} disabled style={{ width: "110px" }} /></td>
                                            <td><input className="p-1" value={moment(entry.transDate).format("DD-MMM-YYYY")} disabled style={{ width: "115px" }} /></td>
                                            <td><input className="p-1" value={moment(entry.periodFrom).format("DD-MMM-YYYY")} disabled style={{ width: "115px" }} /></td>
                                            <td><input className="p-1" value={moment(entry.periodto).format("DD-MMM-YYYY")} disabled style={{ width: "120px" }} /></td>
                                            <td><input className="p-1" value={Number(entry.Rent_Per_period)?.toFixed(currencyPrecision?.decimalNumbers)} disabled style={{ width: "140px" }} /></td>
                                            <td><input className="p-1" value={Number(entry.Security_Deposit)?.toFixed(currencyPrecision?.decimalNumbers)} disabled style={{ width: "140px" }} /></td>
                                            <td><input className="p-1" value={0.000} disabled style={{ width: "130px" }} /></td>
                                            <td><input className="p-1" value={Number(entry.serviceCharges)?.toFixed(currencyPrecision?.decimalNumbers)} disabled style={{ width: "140px" }} /></td>
                                            <td><input className="p-1" value={Number(entry.Parking_Price)?.toFixed(currencyPrecision?.decimalNumbers)} disabled style={{ width: "130px" }} /></td>
                                            <td><input className="p-1" value={Number(entry.leaseFee)?.toFixed(currencyPrecision?.decimalNumbers)} disabled style={{ width: "110px" }} /></td>
                                            <td><input className="p-1" value={Number(entry.rentFree)?.toFixed(currencyPrecision?.decimalNumbers)} disabled style={{ width: "150px" }} /></td>
                                            <td><input className="p-1" value={entry.Installments} disabled style={{ width: "150px" }} /></td>
                                            <td><input className="p-1" value={entry.leaseTerm} disabled style={{ width: "110px" }} /></td>
                                            <td><input className="p-1" value={entry.reservation?.label} disabled /></td>
                                            <td><input className="p-1" value={entry.remarks2} disabled style={{ width: "fit-content" }} /></td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
            <Modal size="md"
                show={msgModal} onHide={() => setmsgModal(false)}
                backdrop="static"
                contentLabel='Confirmation Modal'
            >
                <Modal.Header closeButton>
                    <Modal.Title className='center'>{datamsg}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        Do you want to add Unit
                    </div>
                </Modal.Body>
                <Modal.Footer className='end p-3'>
                    <button className='mainbtnGry' onClick={onCloseModal}>Close</button>
                    <button className='mainbtnRed' onClick={dataset}>Ok</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};
export default RenueLeaseAgrement;
